import FillParams from "./fillParams.service";

const fillParamsModule = angular
  .module("app.services.fillParams", [])
  .service("FillParams", FillParams);

export default fillParamsModule;



// WEBPACK FOOTER //
// ./src/services/fillParams/fillParams.module.js